var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddvideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0703 7.75V15.25",
    stroke: "#5570F1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5099 10.9076L11.5594 7.95712C11.4955 7.89258 11.4194 7.84135 11.3356 7.80638C11.2518 7.77142 11.1619 7.75342 11.0711 7.75342C10.9803 7.75342 10.8904 7.77142 10.8066 7.80638C10.7228 7.84135 10.6467 7.89258 10.5829 7.95712L7.63086 10.9076",
    stroke: "#5570F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 1.47998H6.64251C5.93335 1.47998 5.23115 1.61986 4.57612 1.89161C3.92109 2.16335 3.32609 2.56164 2.82519 3.06365C2.32429 3.56566 1.92734 4.16154 1.65704 4.81717C1.38675 5.47281 1.24844 6.17532 1.25001 6.88448V16.1275C1.25001 17.5577 1.81815 18.9293 2.82944 19.9406C3.33018 20.4413 3.92464 20.8385 4.57889 21.1095C5.23314 21.3805 5.93436 21.52 6.64251 21.52H15.5C16.9302 21.52 18.3018 20.9518 19.3131 19.9406C20.3244 18.9293 20.8925 17.5577 20.8925 16.1275V6.88598C20.8945 6.17664 20.7565 5.47388 20.4863 4.81798C20.2162 4.16208 19.8193 3.56595 19.3183 3.06374C18.8174 2.56153 18.2222 2.16312 17.567 1.89135C16.9118 1.61957 16.2094 1.47978 15.5 1.47998ZM29.75 7.65698V15.3595C29.75 15.7345 29.6435 16.1035 29.4425 16.4215C29.2393 16.7407 28.9509 16.9968 28.61 17.161C28.2716 17.3304 27.8904 17.3951 27.515 17.347C27.1449 17.3029 26.7938 17.1588 26.4995 16.93L21.662 13.048C21.4294 12.857 21.2414 12.6175 21.1111 12.3462C20.9807 12.0749 20.9113 11.7784 20.9075 11.4775C20.9075 11.1775 20.975 10.8835 21.107 10.615C21.245 10.363 21.434 10.1425 21.662 9.96698L26.4995 6.11648C26.794 5.88705 27.1457 5.74281 27.5165 5.69948C27.8915 5.65148 28.2725 5.71598 28.61 5.88548C28.9469 6.04427 29.2325 6.29455 29.434 6.60777C29.6356 6.92099 29.7451 7.28454 29.75 7.65698Z",
    stroke: "#5570F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddvideo);
export default __webpack_public_path__ + "static/media/addvideo.b9dbc49fea86eda3e962961e4186c1d2.svg";
export { ForwardRef as ReactComponent };